// FORMAT PHONE NUMBER FOR UI DISPLAY
import { parsePhone } from './parsePhone';
import { NATIONAL_FORMAT_COUNTRIES } from './constants';

// FORMAT PHONE FOR DISPLAY:
// - US/CA: HYBRID FORMAT "+1 (415) 555-1234" - UNIVERSALLY DIALABLE WITH FAMILIAR FORMATTING
// - OTHERS: INTERNATIONAL FORMAT "+44 20 7946 0958"
// RETURNS ORIGINAL VALUE IF UNABLE TO PARSE
// `country` IS THE ASSUMPTION FOR INPUT WITHOUT A LEADING "+" (CU-86ajrx60c).
// DISPLAY NORMALLY RECEIVES ALREADY-STORED E.164 (WHICH CARRIES ITS OWN "+"),
// SO THE DEFAULT IS RARELY CONSULTED — THREADED FOR CONSISTENCY WITH THE OTHER
// HELPERS AND FOR CALLERS THAT FORMAT RAW INPUT.
export const formatPhoneDisplay = (
  value: string | null | undefined,
  country?: string | null,
): string | null => {
  if (value === null || value === undefined) {
    return null;
  }

  const trimmed = `${value}`.trim();
  if (!trimmed) {
    return null;
  }

  const parsed = parsePhone(trimmed, country);

  if (parsed && parsed.phoneNumber) {
    // US/CA: HYBRID FORMAT - +1 (415) 555-1234
    // COMBINES INTERNATIONAL DIALABILITY WITH FAMILIAR US FORMATTING
    if (parsed.country && NATIONAL_FORMAT_COUNTRIES.includes(parsed.country)) {
      const national = parsed.phoneNumber.formatNational(); // "(415) 555-1234"
      return `+1 ${national}`;
    }
    // INTERNATIONAL: STANDARD FORMAT - +44 20 7946 0958
    return parsed.phoneNumber.formatInternational();
  }

  // FALLBACK: TRY MANUAL FORMATTING FOR 10-DIGIT US NUMBERS
  const cleaned = trimmed.replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    // ALWAYS INCLUDE +1 FOR NORTH AMERICAN FALLBACK
    return ['+1 (', match[2], ') ', match[3], '-', match[4]].join('');
  }

  // RETURN ORIGINAL IF CANNOT FORMAT
  return trimmed;
};
